import { ComplexValue } from 'app/types-shared';

export const getTextInLanguage = (texts: ComplexValue<number>[], mainLanguage: number) => {

  return !!texts && !!mainLanguage
    ? texts.find(text => text.value === mainLanguage)
    : undefined;
};
